import { render, staticRenderFns } from "./InvitationSaraWongPage.vue?vue&type=template&id=6790cffc&scoped=true&"
import script from "./InvitationSaraWongPage.vue?vue&type=script&lang=js&"
export * from "./InvitationSaraWongPage.vue?vue&type=script&lang=js&"
import style0 from "./InvitationSaraWongPage.vue?vue&type=style&index=0&id=6790cffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6790cffc",
  null
  
)

export default component.exports